import React, { useEffect } from "react"
import AppFrequencyHoursAutocomplete from "@components/Autocomplete/FrequencyHours"
import { useReportMultipleModalMultipleEdit } from "Pages/ReportsAlerts/Reports/@hooks"
import { useManualExecution } from "Pages/ReportsAlerts/Reports/@signals"


export default function ReportFrequencyHoursField() {

	const { setFrequency, data } = useReportMultipleModalMultipleEdit("frequencyHours")

	useEffect(() => {
		setFrequency([])
	}, [useManualExecution.value])

	return <AppFrequencyHoursAutocomplete
		disabled={useManualExecution.value}
		label="Execution frequency"
		placeholder="Select frequency hours"
		value={data || []}
		onChange={e => setFrequency(e.target.value)}
	/>
}